<template>
  <section class="section container">
    <div class="title is-3 has-text-centered">{{ $t("loan types") }}</div>

    <loan-type-datatable ref="loan_type_datatable" />
  </section>
</template>

<script>
import LoanTypeDatatable from "./loan_type_datatable/Index.vue";

export default {
  name: "LoanType",
  components: {
    LoanTypeDatatable,
  },
};
</script>
